import {useMemo} from "react";
import {useParams} from "next/navigation";

export const useCompanyId = () => {
  const companyId = useOptionalCompanyId()!
  return {companyId}
}

export const useOptionalCompanyId = () => {
  const companyIdParam = useParams<{ companyId?: string }>().companyId
  return useMemo(() => companyIdParam ? parseInt(companyIdParam) : undefined, [companyIdParam])
}